import React, { useEffect, useState } from 'react';
import { STRAPI_URL } from 'config';
import { IntlProvider as Provider } from 'react-intl';
import { ConfigProvider } from 'antd';
import { useAppState } from 'providers/AppState';
import { flatten } from 'flat';
import axios from 'axios';
import defaultTranslations from '../../lang';

const defaultLocale = 'en';
const IntlProvider = ({ children }) => {
  const { locale } = useAppState();
  const [messages, setMessages] = useState({});
  const [loadedLocale, setLoadedLocale] = useState(defaultLocale);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${STRAPI_URL}?_locale=${locale}`)
      .then(({ data }) => {
        setMessages(data);
        setLoadedLocale(locale);
      })
      .catch(() => {
        setMessages(defaultTranslations?.en);
        setLoadedLocale(defaultLocale);
      })
      .finally(() => setIsLoading(false));
  }, [locale]);

  return (
    <Provider
      messages={flatten(messages) || {}}
      locale={loadedLocale}
      defaultLocale={defaultLocale}
      onError={() => {}}
    >
      <ConfigProvider locale={loadedLocale}>
        {!isLoading && children}
      </ConfigProvider>
    </Provider>
  );
};

export default IntlProvider;
